//
// InsightItem.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "../models/media/MediaType";
import "@sas-dvr/ltjs-commons/models/particles/Link";

var InsightItem = createModule("transport::InsightItem", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel","transport::MediaType"], EventDispatcher, [
    ,
    {
        shared: 2,
        added: 7,
        memberCount: 4,
        description: 7,
        originatingReportLocation: 7,
        type: 7,
        uri: 7,
        createdBy: 7,
        name: 7,
        modifiedTimeStamp: 7,
        modifiedBy: 7,
        links: [1],
        id: 7,
        creationTimeStamp: 7,
        contentType: 7,
        iconUri: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default InsightItem;
